import {
  DistanceUnit,
  FacilityType,
  FacilityWidth,
  FlowDirectionType,
  HeavyVehicleFlowType,
} from "@keita/lanepatrol-sdk";
import { HlaWay, HlaWayType } from "../../hla/models/HlaWay";
import { HlaLane, HlaWayAdjacentFeatures } from "../../hla/models/HlaLane";

export interface CalculateHlaScore {
  distanceUnit: DistanceUnit;
  attributes: HlaCoding[];
}

export interface HlaCoding {
  type: HlaWayType;
  averageDailyTraffic: number | null;
  averageRoadSpeed: number | null;
  heavyVehicleFlow: HeavyVehicleFlowType | null;
  lit: boolean;

  adjacentFeaturesLeft: HlaWayAdjacentFeatures;
  adjacentFeaturesRight: HlaWayAdjacentFeatures;
  flowDirection: FlowDirectionType | null;
  facilityType: FacilityType | null;
  facilityWidthPerDirection: FacilityWidth | null;
  lightSegregation: boolean;
  tramOrTrainRails: boolean;
}

export function buildHlaCoding(way: HlaWay, lane: HlaLane): HlaCoding {
  return {
    type: way.type,
    averageDailyTraffic: way.averageDailyTraffic,
    averageRoadSpeed: way.averageRoadSpeed,
    heavyVehicleFlow: way.heavyVehicleFlow,
    lit: way.lit,

    adjacentFeaturesLeft: lane.adjacentFeaturesLeft,
    adjacentFeaturesRight: lane.adjacentFeaturesRight,
    flowDirection: lane.flowDirection,
    facilityType: lane.facilityType,
    facilityWidthPerDirection: lane.facilityWidthPerDirection,
    lightSegregation: lane.lightSegregation,
    tramOrTrainRails: lane.tramOrTrainRails,
  };
}
